import { routeHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/pl/privacy-policy")({
  head: () => routeHead('Polityka prywatności — AGAPE', 'Dowiedz się, jak AGAPE chroni i przetwarza dane osobowe.', '/pl/privacy-policy'),
  component: PrivacyPolicy,
});
